import { Helmet } from 'react-helmet-async';
// sections
import { HomeView } from 'src/sections/home/view';

// ----------------------------------------------------------------------

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title> MintSteam: Your web3 media destination</title>
      </Helmet>

      <HomeView />
    </>
  );
}
